import type { CaptchaChallenge } from '@/contracts/captcha.contract'
import { request } from './http/client'

/**
 * 圖形驗證碼端點。
 *
 * 路徑與 `api/src/modules/captcha/captcha.routes.ts` 一一對應。
 */
export const captchaApi = {
  issue(): Promise<CaptchaChallenge> {
    return request<CaptchaChallenge>({ method: 'GET', url: '/api/v1/captcha' })
  },
}
